import { all } from 'redux-saga/effects';

import businessesSaga from './businesses/saga';
import customersSaga from './customers/saga';

export default function* saga() {
  yield all([businessesSaga(), customersSaga()]);
}
